const popupFunctions = () => {
    const COOKIE_PREFIX = 'tj_popup_';

    const setCookie = (name, days) => {
        const d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    };

    const hasCookie = (name) => {
        return document.cookie.split('; ').some((c) => c.indexOf(name + '=') === 0);
    };

    const parsePages = (raw) => {
        if ( !raw || raw === 'null' || raw === 'false' ) return [];
        try {
            const parsed = JSON.parse(raw);
            if ( !Array.isArray(parsed) ) return [];
            return parsed.map((v) => parseInt(v, 10)).filter((v) => !isNaN(v));
        } catch (e) {
            return [];
        }
    };

    const openPopup = ($popup) => {
        $popup.addClass('active');
        $('body').addClass('popup-open');
    };

    const closePopup = ($popup) => {
        const id = $popup.attr('id');
        const period = parseInt($popup.attr('data-period'), 10);

        $popup.removeClass('active');
        if ( !$('.popup.active').length ) {
            $('body').removeClass('popup-open');
        }

        if ( id && !isNaN(period) && period > 0 ) {
            setCookie(COOKIE_PREFIX + id, period);
        }
    };

    const shouldAutoShow = ($popup, currentPageId) => {
        const id = $popup.attr('id');
        const type = $popup.attr('data-type');
        const period = parseInt($popup.attr('data-period'), 10);
        const pages = parsePages($popup.attr('data-pages'));

        if ( type === 'trigger' ) return false;

        if ( type === 'include' && pages.indexOf(currentPageId) === -1 ) return false;
        if ( type === 'exclude' && pages.indexOf(currentPageId) !== -1 ) return false;

        if ( id && !isNaN(period) && period > 0 && hasCookie(COOKIE_PREFIX + id) ) {
            return false;
        }

        return true;
    };

    const currentPageId = parseInt($('body').attr('data-page'), 10);

    let delay = 0;
    $('.custom-popup').each(function() {
        const $popup = $(this);
        if ( !shouldAutoShow($popup, currentPageId) ) return;

        setTimeout(() => openPopup($popup), delay);
        delay += 400;
    });

    $(document).on('click', '.js__close-popups', function(e) {
        e.preventDefault();
        const $popup = $(this).closest('.popup');
        if ( $popup.length ) closePopup($popup);
    });

    $(document).on('click', '[data-popup-trigger]', function(e) {
        const id = $(this).attr('data-popup-trigger');
        const $popup = $('#' + id);
        if ( $popup.length ) {
            e.preventDefault();
            openPopup($popup);
        }
    });

    $(document).on('keyup', function(e) {
        if ( e.key === 'Escape' ) {
            $('.popup.active').each(function() {
                closePopup($(this));
            });
        }
    });
};
